import styles from './SavedContentDropdown.module.less';
import { Icon } from '../../shared/Icon/Icon';
import { useDropdownStore } from '../../../stores/dropdownStore';
import { useSavedContent } from '../../../hooks/useSavedContent';

const SavedContentDropdown = ({
  theme,
}: {
  theme: string;
  isMenu?: boolean;
}) => {
  const { toggleDropdown } = useDropdownStore();
  const { savedContent } = useSavedContent();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    toggleDropdown();
  };

  return (
    <div className={styles.savedContentDropdown}>
      <button
        onClick={handleClick}
        className={`${styles.savedContentButton} ${theme !== 'light' ? styles.savedContentButtonDark : ''}`}
      >
        <span className={styles.savedContentNumber}>
          {savedContent.length > 0 && savedContent.length}
        </span>
        <Icon
          id={savedContent.length > 0 ? 'save-active' : 'save'}
          className={`${styles.icon}  ${theme !== 'light' && styles.iconLight}  ${savedContent.length > 0 && theme !== 'light' ? styles.iconActiveLight : ''} ${savedContent.length > 0 && styles.iconActive}`}
        />
      </button>
    </div>
  );
};

export default SavedContentDropdown;
